import { useQuery } from '@tanstack/react-query';
import { getFacturationModes } from '../../api/TICKET/ticketMeta';

export const useFacturationModes = ({ enabled = true } = {}) => {
    return useQuery({
        queryKey: ['facturationModes'],
        queryFn: getFacturationModes,
        staleTime: 5 * 60 * 1000,
        enabled,
    });
};
